import JSelectDisplayOption from "$components/JSelectDisplayOption/JSelectDisplayOption";
import { useCategoriesQuery } from "$hooks/useCategoriesQuery";
import useReferencingCategory from "$hooks/useReferencingCategory";
import GenericSelect from "./GenericSelect";

type Props = {
  onChange: (categoryId, category) => void;
  value: any;
  error?: boolean;
  multiple?: boolean;
  className?: any;
  required?: boolean;
  disabled?: boolean;
  renderOption?: (opt) => JSX.Element;
  companyId?: string;
  allowNoCompany?: boolean;
  label?: string;
  placeholder?: string;
  valueKey?: string;
  showReferencingCategory: boolean;
};

function CategorySelect({
  allowNoCompany = false,
  companyId,
  showReferencingCategory,
  disabled = false,
  label = "Catégories",
  placeholder = "Sélectionnez un produit",
  valueKey = "id",
  ...props
}: Props) {
  const { loading, referencingCategory } = useReferencingCategory(companyId);
  const { data } = useCategoriesQuery(companyId || "");
  const categories = data?.orderedCategories;

  const categoryOptions =
    categories?.filter(
      (c) =>
        !loading &&
        (showReferencingCategory || c.id !== referencingCategory?.id)
    ) || [];
  let placeholderText = placeholder;

  if (categoryOptions.length === 0) {
    placeholderText = "Aucune catégorie pour cette entreprise";
  }

  if (!allowNoCompany && !companyId) {
    placeholderText = "Vous devez d'abord sélectionner une entreprise";
  }

  return (
    <GenericSelect
      valueKey={valueKey}
      label={label}
      placeholder={placeholderText}
      getOptionLabel={(option: any) =>
        `${option?.title} - [${option?.reference}]`
      }
      disabled={
        (!allowNoCompany && !companyId) ||
        disabled ||
        categoryOptions.length === 0
      }
      options={categoryOptions || []}
      renderOption={(props: any) => (
        <JSelectDisplayOption value1={props.title} value2={props.reference} />
      )}
      loading={loading}
      {...props}
    />
  );
}

export default CategorySelect;
